import React from "react";
import { SubList } from "./_forms";

export default function Warnings({ staff }) {
  const staffName = (id) => staff.find((x) => x.id === id)?.full_name || id;
  const issuerOptions = staff.map((s) => [s.id, `${s.full_name} — ${s.designation || s.department || "Staff"}`]);
  return (
    <SubList
      endpoint="/hr/warnings" dataKey="items"
      lookups={{ staff_id: staffName, issued_by: staffName }}
      columns={[
        ["staff_id", "Employee", true], ["warning_type", "Type"],
        ["issue_date", "Issued", "date"], ["issued_by", "Issued By"],
        ["status", "Status", "badge"],
      ]}
      form={[
        { k: "staff_id", label: "Employee", type: "select", options: staff.map((s) => [s.id, `${s.full_name} (${s.employee_code || "—"})`]), required: true },
        { k: "warning_type", label: "Type", type: "select", required: true, options: [
          ["verbal", "Verbal"], ["written", "Written"], ["final", "Final"],
          ["suspension", "Suspension"], ["termination_notice", "Termination Notice"],
        ]},
        { k: "issue_date", label: "Issue Date", type: "date", required: true },
        { k: "reason", label: "Reason", textarea: true, required: true },
        { k: "issued_by", label: "Issued By", type: "select", options: issuerOptions, required: true },
      ]}
      testId="warn"
      emptyText="No disciplinary actions recorded."
    />
  );
}
